import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';
import type { ErrorProps } from './Error.types';

export const LazyError: FunctionComponent<ErrorProps> = (props) => {
  const Error = useLazyComponent(
    () => import(/* webpackChunkName: "error" */ 'app/src/components/Error'),
    { namedImport: 'Error' },
  );
  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <Error {...props} />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
